import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setOpenAddArticleAPI, setOpenARMainMenu, setOpenArticleManagment, setOpenChoiceComponentAR, setOpenEnteringDataAR, setOpenMainMenu, setOpenModalAddCity, setOpenModalAddUser, setOpenSummaryReport, setOpenUserManagment, TransitionSystem } from "../../Reducer/ModalSlice";
import { FaPencil, FaRegCalendar, FaStore, FaUserTie, FaPlus, FaNewspaper, FaFolderPlus, FaCheck } from "react-icons/fa6";
import { FaSyncAlt } from "react-icons/fa"
import { addCityArrayReport, CityArrayAdd, CityFromAddUserAdd } from "../../Reducer/CitySlice";
import { addUsers } from "../../Reducer/UserSlice";
import axios from "axios";
import { MonthArrayAddAR } from "../../Reducer/MonthSliceAR";
import { AddArrayAdvanceReport } from "../../Reducer/AdvanceReprotsSlice";
import { roleId } from "../../Components/Constants/app";

function ChoiceComponentAR() {
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const CityArray = useSelector(state => state.CitySlice.CityArray)

    const MonthArrayAR = useSelector(state => state.MonthSliceAR.MonthArrayAR)

    const OpenARMainMenu = useSelector(state => state.ModalSlice.OpenModal.OpenARMainMenu)

    const AdvanceReportED = useSelector(state => state.AdvanceReprotsSlice.AdvanceReportED)

    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)


    const dispatch = useDispatch()

    const getCity = async () =>  {
        var CityArrayChecked = []
        var CityCheck 
            await axios.get(Server + 'cities?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                }
            })
            .then((response) => {
                if([roleId.admin, roleId.operatingDirector].includes(User.user.role.id) || User.user.idCity === 'all')
                    {
                        dispatch(CityArrayAdd(response.data))
                    }
                    else
                    {
                        CityCheck = response.data
                    }
                })
    
                if(![roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && User.user.idCity !== 'all')
                {
                    await User.user.idCity.map((el) => {
                        CityCheck.map((a) => {
                            if(parseInt(a.id) === parseInt(el))
                            {
                                CityArrayChecked.push(a)
                            }
                            return(a)
                        })
                        return(el)
                    })
                    await dispatch(CityArrayAdd(CityArrayChecked))
            }
    }

    const getMounth = () => {
        axios.get(Server + 'monthforadvancereports?_limit=-1&_sort=id:DESC', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            dispatch(MonthArrayAddAR(response.data))
        })
    }

    const getCityAdvancereport = async () => {
        setLoading(false)
        await axios.get(Server + 'cityadvancereports?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then(async (response) => {
            await dispatch(AddArrayAdvanceReport(response.data))
            setLoading(true)
        })
    }

    const handleAddMonth = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        setLoading(false)        

        let NewMonthValue = ''
        let NewYearValue = ''
        let NewName = ''

        if(MonthArrayAR[0].MonthValue !== 12)
        {
            NewMonthValue = parseInt(MonthArrayAR[0].MonthValue) + 1
            NewYearValue = parseInt(MonthArrayAR[0].YearValue)
        }
        else
        {
            NewMonthValue = 1
            NewYearValue = parseInt(MonthArrayAR[0].YearValue) + 1
        }

        switch(NewMonthValue){
            case(1):{
                NewName = 'Январь ' + NewYearValue
                break;
            }
            case(2):{
                NewName = 'Февраль ' + NewYearValue
                break;
            }
            case(3):{
                NewName = 'Март ' + NewYearValue
                break;
            }
            case(4):{
                NewName = 'Апрель ' + NewYearValue
                break;
            }
            case(5):{
                NewName = 'Май ' + NewYearValue
                break;
            }
            case(6):{
                NewName = 'Июнь ' + NewYearValue
                break;
            }
            case(7):{
                NewName = 'Июль ' + NewYearValue
                break;
            }
            case(8):{
                NewName = 'Август ' + NewYearValue
                break;
            }
            case(9):{
                NewName = 'Сентябрь ' + NewYearValue
                break;
            }
            case(10):{
                NewName = 'Октябрь ' + NewYearValue
                break;
            }
            case(11):{
                NewName = 'Ноябрь ' + NewYearValue
                break;
            }
            case(12):{
                NewName = 'Декабрь ' + NewYearValue
                break;
            }
            default:{
                break;
            }
        }
        
            await axios.post(Server + 'monthforadvancereports', {
                        Name: String(NewName),
                        YearValue:  parseInt(NewYearValue),
                        MonthValue:  parseInt(NewMonthValue)
                }, {
                    headers: {
                    Authorization: 'Bearer ' + User.jwt,
                    },
                })
                .then(() => {
                    setSuscessLoading(true)
                    CityArray.map((el) =>{     
                        let ResponsiblesUsersChek = {
                            ManagerName: '',
                            AccountantName: ''
                        }
                        
                        if(el.NameResponsibleUser)
                            ResponsiblesUsersChek.ManagerName = String(el.NameResponsibleUser)
        
                        if(el.NameAccountantUser){
                            ResponsiblesUsersChek.AccountantName = String(el.NameAccountantUser)
                        }

                        let PercentChek = 100
                            if(AdvanceReportED.filter((item) => item.idCity === el.id)[AdvanceReportED.filter((item) => item.idCity === el.id).length - 1].PercentRemains)
                                PercentChek = AdvanceReportED.filter((item) => item.idCity === el.id)[AdvanceReportED.filter((item) => item.idCity === el.id).length - 1].PercentRemains

                        let DirectorCheck = null
                        if(AdvanceReportED.filter((item) => item.idCity === el.id)[AdvanceReportED.filter((item) => item.idCity === el.id).length - 1].DirectorID)
                            DirectorCheck = AdvanceReportED.filter((item) => item.idCity === el.id)[AdvanceReportED.filter((item) => item.idCity === el.id).length - 1].DirectorID

                            return(
                            axios.post(Server + 'cityadvancereports', {
                            idCity: parseInt(el.id),
                            YearValue: parseInt(NewYearValue),
                            MonthValue: parseInt(NewMonthValue),
                            BlockEdit: false,
                            PercentRemains: PercentChek,
                            DirectorID: DirectorCheck,
                            Articles: [],
                            AdminArticles: [],
                            ResponsiblesUsers: {
                                ManagerName: ResponsiblesUsersChek.ManagerName,
                                AccountantName: ResponsiblesUsersChek.AccountantName
                            }
                        }, {
                            headers: {
                            Authorization: 'Bearer ' + User.jwt,
                            },
                        })
                        .then(() => {
                            setSuscessLoading(true)
                        })
                        .catch((er) => {
                            setSuscessLoading(false)
                            axios.get(Server + 'monthforadvancereports?_limit=-1&_sort=id:DESC', {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                },
                                params:{
                                    YearValue: parseInt(NewYearValue),
                                    MonthValue: parseInt(NewMonthValue)
                                }})
                                .then((response) => {
                                    axios.delete(Server + 'monthforadvancereports' + response.data[0].id, {
                                        headers: {
                                            Authorization: 'Bearer ' + User.jwt,
                                        }})
                                })
                            alert('Что-то пошло не так, обновите страницу и повторите попытку ' + er)
                        })      
                        )
                    })
                })
                .catch(() => {
                    setSuscessLoading(false)
                    alert('Что-то пошло не так, обновите страницу и повторите попытку')
                })           

            await getCity()      
            await getMounth()      
            setLoading(true)
            setTimeout(() => {
                setSuscessLoading(false)
            }, 500)        
    }

    useEffect(() => {
        getCity()
        getMounth()
        getCityAdvancereport()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ChoiceSystemMainDiv"
            >
                <div
                className="ChoiceSystemColumnDiv"
                >
                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(async () => {
                        await dispatch(setOpenEnteringDataAR(true))
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            await dispatch(setOpenEnteringDataAR(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        }             
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaPlus/> </div> Внесение данных
                    </button>

                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(async () => {
                        await dispatch(addCityArrayReport())
                        await dispatch(setOpenSummaryReport(true))
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            await dispatch(addCityArrayReport())
                            await dispatch(setOpenSummaryReport(true))
                            dispatch(setOpenChoiceComponentAR(false))                            
                        }             
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaNewspaper/> </div> Сводные отчеты
                    </button>

                    {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) &&
                    <>
                        <button
                        className="ChoiceSystemMainButton Options HiddenMobile"
                        onClick={(() => {
                            dispatch(setOpenAddArticleAPI(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        })} 
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                dispatch(setOpenAddArticleAPI(true))
                                dispatch(setOpenChoiceComponentAR(false))
                            }
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"> <FaFolderPlus/> </div> Добавить статью
                        </button>

                        <button
                        className="ChoiceSystemMainButton Options HiddenMobile"
                        onClick={(() => {
                            dispatch(setOpenArticleManagment(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        })} 
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                dispatch(setOpenArticleManagment(true))
                                dispatch(setOpenChoiceComponentAR(false))
                            }
                        })}
                        >
                            <div className="IconButtonMainMenuDiv"> <FaPencil/> </div> Изменение статей
                        </button>
                    </>
                    }
                </div>

                {User.user.role.id=== roleId.admin &&
                <div
                className="ChoiceSystemColumnDiv HiddenMobile"
                >
                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(() => {
                        dispatch(setOpenModalAddCity(true))
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenModalAddCity(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaStore/> </div> Добавить филиал
                    </button>

                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(async (event) => {
                        await getCity()
                        handleAddMonth(event) 
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            await getCity()
                            handleAddMonth(event)        
                        }                
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"><FaRegCalendar/></div> Добавить месяц
                    </button>

                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(() => {
                        getCity()
                        dispatch(setOpenModalAddUser(true))
                        dispatch(CityFromAddUserAdd())
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            getCity()
                            dispatch(setOpenModalAddUser(true))
                            dispatch(CityFromAddUserAdd())
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"><FaUserTie/></div> Добавить пользователя
                    </button>

                    <button
                    className="ChoiceSystemMainButton Options"
                    onClick={(async () => {
                        dispatch(CityFromAddUserAdd())
                        await axios.get(Server + "users?_limit=-1", {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                        .then((response) => {
                            var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                            dispatch(addUsers(addedUsersArray))
                            getCity()
                            dispatch(setOpenUserManagment(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        })
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(CityFromAddUserAdd())
                            await axios.get(Server + "users?_limit=-1", {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            })
                            .then((response) => {
                                var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                                dispatch(addUsers(addedUsersArray))
                                getCity()
                                dispatch(setOpenUserManagment(true))                            
                                dispatch(setOpenChoiceComponentAR(false))
                            })
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"><FaPencil /></div> Пользователи
                    </button>
                </div>
                }
            </div>

            <div
            className={OpenARMainMenu ? "MainMenuOptionsDiv AR" : "MainMenuOptionsDiv AR Close"}
            >
                <div
                className="MainMenuColumnDiv Options"
                >
                    {[roleId.admin, roleId.operatingDirector].includes(User.user.role.id) && 
                    <>
                    <button
                    className="ButtonMainMenu Options"
                    onClick={(() => {
                        dispatch(setOpenARMainMenu(false))
                        dispatch(setOpenAddArticleAPI(true))
                        dispatch(setOpenChoiceComponentAR(false))
                    })} 
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenARMainMenu(false))
                            dispatch(setOpenAddArticleAPI(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaFolderPlus/> </div> Добавить статью
                    </button>

                    <button
                    className="ButtonMainMenu Options"
                    onClick={(() => {
                        dispatch(setOpenARMainMenu(false))
                        dispatch(setOpenArticleManagment(true))
                        dispatch(setOpenChoiceComponentAR(false))
                    })} 
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenARMainMenu(false))
                            dispatch(setOpenArticleManagment(true))
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaPencil/> </div> Изменение статей
                    </button>

                    <button
                    className="ButtonMainMenu Options"
                    onClick={(() => {
                        dispatch(setOpenModalAddCity(true))
                        dispatch(setOpenARMainMenu(false))
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenModalAddCity(true))                            
                            dispatch(setOpenARMainMenu(false))
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"> <FaStore/> </div> Добавить филиал
                    </button>

                    <button
                    className="ButtonMainMenu Options"
                    onClick={handleAddMonth}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleAddMonth(event)
                    }}
                    >
                        <div className="IconButtonMainMenuDiv"><FaRegCalendar/></div> Добавить месяц
                    </button>

                    <button
                    className="ButtonMainMenu Options"
                    onClick={(() => {
                        dispatch(setOpenModalAddUser(true))
                        dispatch(CityFromAddUserAdd())
                        dispatch(setOpenARMainMenu(false))
                        dispatch(setOpenChoiceComponentAR(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenModalAddUser(true))
                            dispatch(CityFromAddUserAdd())
                            dispatch(setOpenARMainMenu(false))
                            dispatch(setOpenChoiceComponentAR(false))
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"><FaUserTie/></div> Добавить пользователя
                    </button>

                    <button
                    className="ButtonMainMenu Options"
                    onClick={(async () => {
                        dispatch(CityFromAddUserAdd())
                        await axios.get(Server + "users?_limit=-1", {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            }
                        })
                        .then((response) => {
                            var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                            dispatch(addUsers(addedUsersArray))
                            dispatch(setOpenUserManagment(true))
                            dispatch(setOpenARMainMenu(false))
                            dispatch(setOpenChoiceComponentAR(false))
                        });
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(CityFromAddUserAdd())
                            await axios.get(Server + "users?_limit=-1", {
                                headers: {
                                    Authorization: 'Bearer ' + User.jwt,
                                }
                            })
                            .then((response) => {
                                var addedUsersArray = response.data.filter(el => el.role.id !== roleId.admin)
                                dispatch(addUsers(addedUsersArray))
                                dispatch(setOpenUserManagment(true))
                                dispatch(setOpenARMainMenu(false))
                                dispatch(setOpenChoiceComponentAR(false))
                            })
                        }
                    })}
                    >
                        <div className="IconButtonMainMenuDiv"><FaPencil /></div> Пользователи
                    </button>
                    </>
                    }

                    <button
                    className="ButtonMainMenu Options BetweenSystems"
                    onClick={(async () => {
                    await dispatch(TransitionSystem())
                    await dispatch(setOpenMainMenu(true))
                    })}
                    onTouchStart={() => {
                    setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(async (event) => {
                    event.preventDefault()
                    if(!CancelTouch)
                    {
                        await dispatch(TransitionSystem())
                        await dispatch(setOpenMainMenu(true))
                    }
                    })}
                    >
                    <div className="IconButtonMainMenuDiv"> <FaSyncAlt /> </div> Выбор модуля
                    </button>
                </div>
            </div>

                <div
                className={OpenARMainMenu ? "BlackoutMainMenuOptionsDiv" : "BlackoutMainMenuOptionsDiv Close"}
                onClick={(() => {
                    dispatch(setOpenARMainMenu(false))
                })}
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={((event) => {
                    event.preventDefault()
                    if(!CancelTouch)
                        dispatch(setOpenARMainMenu(false))
                })}
                />
        </div>
    )
}
export default ChoiceComponentAR;